/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description utils for preparing FHIR data types
 */

import _ from 'lodash';

const createIdentifier = ({ value, system }: { value: string; system: string }): Fhir.Identifier => {
	return {
		system,
		value,
	};
};

const createName = ({
	givenName,
	lastName,
	displayName,
}: {
	givenName: string[];
	lastName: string;
	displayName?: string;
}): Fhir.HumanName => {
	return {
		text: displayName,
		family: lastName,
		given: givenName,
	};
};

const createAddress = ({
	city,
	state,
	line,
	postalCode,
	country,
}: {
	city?: string;
	line?: string[];
	state?: string;
	country?: string;
	postalCode?: string;
}): Fhir.Address | undefined => {
	// Create an object with only non-empty values
	const address = _.pickBy(
		{
			line: _.isEmpty(_.compact(line)) ? undefined : line,
			city,
			state,
			postalCode,
			country,
		},
		(value) => !_.isEmpty(value),
	);

	return _.isEmpty(address) ? undefined : (address as Fhir.Address);
};

export { createIdentifier, createName, createAddress };
